import {createSlice} from "@reduxjs/toolkit";
import {
    activateSupportPlugin,
    fetchConfig,
    saveBasicInfo,
    saveConfig,
    saveIosAppStoreConfig,
    saveNotificationConfig
} from "./configThunks";

export const configSlice = createSlice({
    name: 'config',
    initialState: {
        config: {},
        loadingSupportPluginSlug: '',
        activeSupportPlugin: '',
        loading: true,
        error: null,
    },
    reducers: {
        updateConfig: (state, action) => {
            state.config = {
                ...state.config,
                ...action.payload
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchConfig.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
                state.activeSupportPlugin = action.payload?.extensions[0] || ''; // Assuming the first extension is the active one
            })
            .addCase(fetchConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })




            .addCase(saveConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
            })
            .addCase(saveConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })




            .addCase(activateSupportPlugin.pending, (state, action) => {
                state.loading = true;
                state.error = null;
                state.loadingSupportPluginSlug = Object.keys(action?.meta?.arg)[0] || ''; // Use the first key of the payload as the loading state
            })
            .addCase(activateSupportPlugin.fulfilled, (state, action) => {
                state.loading = false;
                state.loadingSupportPluginSlug = '';
                state.activeSupportPlugin = action.payload?.extensions[0] || ''; // Assuming the first extension is the active one

                state.config = {
                    ...state.config,
                    extensions: action.payload.extensions || []
                }

                // state.config = action.payload;
            })
            .addCase(activateSupportPlugin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
                state.loadingSupportPluginSlug = '';
            })





            .addCase(saveIosAppStoreConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
            })
            .addCase(saveIosAppStoreConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(saveNotificationConfig.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
            })
            .addCase(saveNotificationConfig.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })




            .addCase(saveBasicInfo.fulfilled, (state, action) => {
                state.loading = false;
                state.config = action.payload;
            })
            .addCase(saveBasicInfo.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
        ;
    }
})

export const {updateConfig} = configSlice.actions;
export default configSlice.reducer;